import { createFileRoute } from '@tanstack/react-router'

import { GlobalRoleType } from '@beaded/models'

import { requireGlobalRole } from 'lib/routeGuards'

import ForecastRequestsAdmin from 'pages/Landing/admin/ForecastRequestsAdmin'

export const Route = createFileRoute('/_auth/_global/forecast-requests')({
  beforeLoad: requireGlobalRole(GlobalRoleType.GLOBAL_ADMIN),
  component: ForecastRequestsAdmin,
})
